<template>
  <div id="app">
    <table-head-drawer
      :title="drawerTitle"
      :drawerVisible="drawerVisible"
      :headerKey="headerKey"
      :checked="checkedHeader"
      :keyToName="keyToName"
      @change-state="changeState"
    ></table-head-drawer>
    <el-container style="height: 100%">
      <router-view/>
    </el-container>
  </div>
</template>

<script>
import TableHeadDrawer from "@/components/drawer/TableHeadDrawer.vue";
export default {
  name: 'App',
  components: {
    'table-head-drawer': TableHeadDrawer,
  },
  data() {
    return {
      drawerTitle: '',
      drawerVisible: false,
      currentPage: {},
      headerKey: ['name'],
      checkedHeader: ['名称'],
      childrenObject: {},
      saveHeaderType: 'checkedHeaders',
      keyToName: this.$commondata.KEY_TO_NAME
    }
  },
  async mounted(){
    // //let url = window.location.href;
    // let pathname = window.location.pathname;
    // console.log(pathname)
    // if(pathname != '/')
    //   await this.$router.push(pathname);
  },
  methods: {
    changeState(options){
      this.drawerVisible = options.isShow;
      if(options.refresh){
        this.childrenObject.$set(this.childrenObject,'checkedHeaders',options.newSortList);
        localStorage.setItem(this.saveHeaderType,this.childrenObject.checkedHeaders);
        this.childrenObject.$nextTick(() => {
          this.childrenObject.$refs.record_table.doLayout();
        });
      }
    }
  }
}
</script>

<style>
html,body{
  margin: 0;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

.el-dialog__body{
  padding: 0 20px 30px 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue